class AssistantAPISources {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/assistant-api-sources`;

  }

  createAPISource(data) {

    const path = `${this.basePath}`;

    return this.apiClient.post(path, {}, {}, data);

  }

  getInternalAssistantAPISources() {

    const path = `${this.basePath}`;

    return this.apiClient.get(path, {}, {});

  }

  deleteAssistantAPISource(assistantAPISourceId) {

    const path = `${this.basePath}/:assistantAPISourceId`;

    return this.apiClient.delete(path, { assistantAPISourceId });

  }

  createAPISourceSecret(assistantAPISourceId, secret) {

    const path = `${this.basePath}/:assistantAPISourceId/secrets`;

    return this.apiClient.post(path, { assistantAPISourceId }, {}, secret);

  }

  updateAPISourceSecret(assistantAPISourceId, secretId) {

    const path = `${this.basePath}/:assistantAPISourceId/secrets/:secretId`;

    return this.apiClient.put(path, { assistantAPISourceId, secretId }, {}, {});

  }

  deleteAPISourceSecret(assistantAPISourceId, secretId) {

    const path = `${this.basePath}/:assistantAPISourceId/secrets/:secretId`;

    return this.apiClient.delete(path, { assistantAPISourceId, secretId });

  }

  createAPISourceEndpoint(apiSourceId, data) {

    const path = `${this.basePath}/:apiSourceId/endpoints`;

    return this.apiClient.post(path, { apiSourceId }, {}, data);

  }

  updateAPISourceEndpoint(apiSourceId, endpointId, data) {

    const path = `${this.basePath}/:apiSourceId/endpoints/:endpointId`;

    return this.apiClient.put(path, { apiSourceId, endpointId }, {}, data);

  }

  deleteAPISourceEndpoint(apiSourceId, endpointId) {

    const path = `${this.basePath}/:apiSourceId/endpoints/:endpointId`;

    return this.apiClient.delete(path, { apiSourceId, endpointId });

  }

  searchEndpoints(queryOptions) {

    const path = `${this.basePath.replace('/assistant-api-sources', '/api-sources')}/endpoints/search`;

    return this.apiClient.get(path, {}, queryOptions);

  }

}

export default AssistantAPISources;